import styled from 'styled-components';

export const StyledEmptyBoxContainer = styled.div`
  display: grid;
  place-content: center;
  margin-top: 50px;
`;

export const StyledEmptyBoxText = styled.div`
  text-align: center;
  font-size: 14px;
  color: rgb(67, 67, 67);
`;
